import React, { useEffect } from "react";
import { connect } from "react-redux";
import styled from 'styled-components';

import DynamicForm from '../../../../../components/DynamicFormNew/index';
import { actions } from '../../../../../store/reducers/go';
import { MessageTypes } from "../../../../../helpers/Messages";

const Styles = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	.form {
		max-width: 630px;
		flex-grow: 1;
		padding: var(--size);
		overflow-y: auto;
		height: 100%;
	}
	.forms {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		overflow-y: auto;
		width: 350px;
		max-height: 100%;
		height: 100%;
		background: #fafafa;
		border-right: 1px solid rgba(0,0,0,0.1);
		button {
			display: flex;
			flex-direction: row;
			justify-content: start;
			align-items: center;
			text-align: start;
			height: fit-content;
			padding: var(--size);
			white-space: pre-wrap;
			> span[role="img"]:nth-of-type(1) {
				font-size: var(--size-lg);
				color: rgba(0, 0, 0, 0.55);
				margin-right: var(--size);
			}
			> div {
				width: 100%;
				align-items: center;
				span {
					font-size: 14px;
				}
				> div {
					span:nth-of-type(1) {
						font-weight: 500;
						color: rgba(0, 0, 0, 0.65);
					}
					span:nth-of-type(2) {
						font-size: 12px;
						color: rgba(0, 0, 0, 0.55);
					}
				}
			}
		}
		button.active {
			background: rgba(161, 194, 250, 0.16);
			border: none;
			> span[role="img"]:nth-of-type(1) {
				color: var(--mmt-primary-70);
			}
			> div {
				> div {
					span:nth-of-type(1) {
						color: var(--mmt-primary-70);
					}
				}
			}
		}
	}
`

const mstp = ({ forms, go }) => ({
  forms,
  go,
});
function GOReportCreate({
  onSubmitted,
  go: { data: formData },
  goDataGet,
  goSubmit,
  activeFormIndex
}) {
  const spKey = 'cadd-scoping';

  const { data = {}, form = {} } = formData[spKey] || {
    data: {},
    form: {}
  }

  useEffect(() => {
    if (!formData[spKey]) {
      goDataGet({ namespace: 'GO', module: 'cadd', view: 'scoping' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData[spKey]])

  return <Styles>
    <DynamicForm
      form={form}
      data={data}
      module={'cadd'}
      activeFormIndex={activeFormIndex}
      submit={(payload, setSelectedFormNext) => {
        const callback = (type, message) => {
          if (type === MessageTypes.SUCCESS) {
            if (setSelectedFormNext) {
              setSelectedFormNext()
            }
            if (onSubmitted) onSubmitted(type, message);
          }
        }
        goSubmit((!data && !data.id)
          ? payload
          : Object.assign(payload, { id: data.id }), callback);
      }}
    ></DynamicForm>
  </Styles>
}


export default connect(mstp, actions)(GOReportCreate);
